import * as React from 'react';
import { useState } from 'react';
import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import './Dropdown.scss';

interface DropdownProps {
  icon: React.ReactElement;
  dropdownOptions: React.ReactElement[];
  tooltipText?: string;
}

export function Dropdown({ icon, dropdownOptions, tooltipText }: DropdownProps) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdownOpen = () => {
    setDropdownOpen((prevState) => !prevState);
  };

  return (
    <Box className="sub_navigation_group">
      <div onClick={toggleDropdownOpen}>
        <Tooltip title={tooltipText}>{icon}</Tooltip>
      </div>
      <Menu
        id="menu-appbar"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        onClick={toggleDropdownOpen}
        open={dropdownOpen}
      >
        {dropdownOptions}
      </Menu>
    </Box>
  );
}
